import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import Gray_Btn from "../../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Success_Toster from "../../../../../../../../common/common_modal/success_toster/Success_Toster";

const Training_Report_Filter = ({setShow}) => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setError,
  } = useForm();

  const countries = [
    { label: "India", value: "1" },
    { label: "USA", value: "2" },
    { label: "UK", value: "3" },
  ];

      const [success, setSuccess] = useState(false);
    // ⏱ auto hide toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  return (
    <section className="Sample_Report_Filter">
      <div className="row me-0 ms-0">
        <div className="col-lg-10">
          <div className="common_filter_div">
            <div className="row">
              <div className="col-xxl-9 col-xl-12 col-lg-12 col-md-9">
                <Form className="form_div">
                  <div className="row">
                    <div className="col-xxl-8 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="filter_div border_div">
                        <Form.Label>Filter By:</Form.Label>
                        <Form.Group>
                          <div className="row">
                            <div className="col-xxl-4 col-md-4 col-sm-4 col-12">
                              <Controller
                                control={control}
                                name="country_id"
                                rules={{ required: "Country is required" }}
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    options={countries}
                                    placeholder="Designation"
                                  />
                                )}
                              />
                            </div>
                            <div className="col-xxl-4 col-md-4 col-sm-4 col-6">
                              <Controller
                                control={control}
                                name="country_id"
                                rules={{ required: "Country is required" }}
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    options={countries}
                                    placeholder="Experience"
                                  />
                                )}
                              />
                            </div>
                            <div className="col-xxl-4 col-md-4 col-sm-4 col-6">
                              <Controller
                                control={control}
                                name="country_id"
                                rules={{ required: "Country is required" }}
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    options={countries}
                                    placeholder="Specialization"
                                  />
                                )}
                              />
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="col-xxl-4 col-xl-8 col-lg-8 col-md-8 col-sm-8 col-11">
                      <div className="filter_div ">
                        <Form.Label>Sort By Date:</Form.Label>
                        <Form.Group>
                          <div className="row">
                            <div className="col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Control
                                type="text"
                                placeholder="Start Date"
                              />
                            </div>
                            <div className="col-md-6 col-sm-6 col-6">
                              <Form.Control
                                type="text"
                                placeholder="End Date"
                              />
                            </div>
                           
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>

              <div className="col-xxl-3 col-xl-3 col-lg-12 col-md-3">
                <div className="btns_holder">
                  {success ? (
                    <Success_Toster successText="Report Generated Successfully!" />
                  ) : (
                    <>
                      <Gray_Btn btnText="Cancel" />
                      <Black_Submit_Btn
                        btnText="Submit"
                        onClick={() => setSuccess(true)}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-2 p-0">
          <div className="add_sample_div" onClick={() => setShow(true)}>
            <div className="add_img_div">
              <img src="/assets/images/other/report.png" className="add_img" />
            </div>
            <p className="inner_text">Generate Report</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Training_Report_Filter;
